const styles = {
  expansionPanel: {
    background: '#f5f5f5',
    textAlign: 'left'
  } as React.CSSProperties
} 

export default styles;